var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader-item"},[_c('div',{staticClass:"preloader-item__loader"},[_c('svg',{staticClass:"preloader-item__circle",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"preloader-item__path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"4","stroke-miterlimit":"10"}})])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb3c802","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreloaderItem/PreloaderItem.vue
// module id = null
// module chunks = 